import Table from '../../../../../components/stateful/table/Table';
import { usePublicProposedController } from './PublicProposedController';
import CustomDialog from '../../../../../components/stateless/dialog/CustomDialog';
import DocketDetails from './docketDetails/DocketDetails';
import RichTextEditor from '../../../../../components/stateful/richTextEditor/RichTextEditor';
import ClickableZone from '../../../../../components/stateless/clickableZone/ClickableZone';
import HtmlRender from '../../../../../components/stateless/htmlRender/HtmlRender';


const PublicProposedPage = () => {
  const {
    //redux
    values,
    fetchingValues,
    //values
    columnData,
    docketDetails,
    docketDetailsOpen,
    selectedFilingId,
    editCmsOpen,
    cmsTitle,
    isAdmin,
    docketCmsItem,
    cmsText,
    //functions
    onRowClick,
    toggleDocketDetails,
    toggleCmsEdit,
    handleCmsItemClick,
    onCmsItemSave,
  } = usePublicProposedController();

  return (
    <div>
      <CustomDialog
        open={editCmsOpen}
        hideButtons
        toggleDialog={toggleCmsEdit}
        cancelAction={toggleCmsEdit}
        title={`Edit ${cmsTitle}`}
        size='large'
      >
        <RichTextEditor content={cmsText ?? ''} height={'40vh'} onSave={onCmsItemSave}></RichTextEditor>
      </CustomDialog>
      {!!docketCmsItem?.cmsItemValue && (
        <div className="info-text">
          <ClickableZone onClick={() => handleCmsItemClick(docketCmsItem.id ?? -1)} active={isAdmin}>
            <HtmlRender value={docketCmsItem.cmsItemValue ?? ""} className='' />
          </ClickableZone>
        </div>
      )}
      <Table
        tableName=''
        columns={columnData}
        values={values}
        height='90vh'
        group={[{field: "agencyName"}]}
        notPageable
        notFilterable
        notSortable
        onRowClick={onRowClick}
        isLoading={fetchingValues}
        wrapHeaders
        isDocket={true}
      />
      <CustomDialog
        title='Docket Details'
        open={docketDetailsOpen}
        toggleDialog={toggleDocketDetails}
        hideButtons
        size='large'
      >
        {!!docketDetails && !!selectedFilingId && (
          <DocketDetails 
            docketDetails={docketDetails} 
            filingId={selectedFilingId}
          />
        )}
      </CustomDialog>
    </div>
  );
}

export default PublicProposedPage